import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type AskQueryInThreadMutationVariables = Types.Exact<{
   params: Types.AskQueryInThreadParams
}>

export type AskQueryInThreadMutation = {
   __typename?: 'Mutation'
   askQueryInThread:
      | {
           __typename?: 'AskQueryInThreadResult'
           message: {
              __typename?: 'ThreadMessage'
              messageId: number
              date: string
              content: string
              timestamp: string
              senderId: string
           }
        }
      | { __typename?: 'ThreadAccessDenied' }
      | { __typename?: 'ThreadNotFound' }
}

export const AskQueryInThreadDocument = gql`
   mutation AskQueryInThread($params: AskQueryInThreadParams!) {
      askQueryInThread(params: $params) {
         ... on AskQueryInThreadResult {
            message {
               messageId
               date
               content
               timestamp
               senderId
            }
         }
      }
   }
`
export type AskQueryInThreadMutationFn = Apollo.MutationFunction<
   AskQueryInThreadMutation,
   AskQueryInThreadMutationVariables
>
export type AskQueryInThreadMutationResult = Apollo.MutationResult<
   AskQueryInThreadMutation
>
export type AskQueryInThreadMutationOptions = Apollo.BaseMutationOptions<
   AskQueryInThreadMutation,
   AskQueryInThreadMutationVariables
>
